import React from "react";
import ResponderMap from "features/Responder/features/ResponderMap/index";

const ZoneMapView = (props) => (
  <ResponderMap
    editable={false}
    enableZones={true}
    enableTools={false}
    enableContextMenu={false}
    activeSelectionOnly={true}
    autoSelectZones={false}
    {...props}
  />
);

export default ZoneMapView;
